<template>
  <div class="auth-description">
    <h2 class="auth-title">{{ $t('Complete') }} “{{ team }}” {{ $t('registration') }}</h2>
    <div>
      <span class="text text-grey">
        {{
          $t(
            'Fill in the remaining fields below in order to complete registration and participate in tender'
          )
        }}
      </span>
    </div>
    <Form class="login-form auth" :success="isDone" @submit="submit">
      <FormInput
        id="name-input"
        v-model="name"
        required
        :max-length="32"
        :label-text="$t('Name')"
        :placeholder="$t('Enter your name')"
      />

      <FormInput
        id="email-input"
        v-model="email"
        type="email"
        disabled
        :error="!!serverErrors.email"
        :error-message="serverErrors.email"
        placeholder="e.g. john@gmail.com"
        :label-text="$t('Email')"
      />

      <div class="register-passwords">
        <FormInput
          id="phone"
          v-model="phone"
          :error="!!serverErrors.phone_number"
          :error-message="serverErrors.phone_number"
          :placeholder="$t('Enter phone')"
          :label-text="$t('Phone number')"
          type="tel"
          required
        />
        <FormInput
          id="position"
          v-model="position"
          :placeholder="$t('Enter position')"
          :label-text="$t('Position in company')"
          required
        />
      </div>
      <div class="register-passwords formcell">
        <FormInput
          id="pass-input"
          v-model="password"
          type="password"
          :error="$v.password.$error"
          :error-message="$t('At least 6 characters with number')"
          :placeholder="$t('Enter your password')"
          :input-info="$t('At least 6 characters with number')"
          :label-text="$t('Password')"
          :success="samePasswords"
        />

        <FormInput
          id="pass2-input"
          v-model="password2"
          type="password"
          :error="$v.password2.$error"
          :error-message="$t('Passwords don’t match')"
          :placeholder="$t('Repeat your password')"
          :label-text="$t('Repeat')"
          :success="samePasswords"
        />
      </div>
      <Button action-type="submit" :loading="isLoading" fill>
        {{ $t('Continue') }}<Vector class="ml-12" />
      </Button>
    </Form>
  </div>
</template>

<script>
  import FormInput from '@/components/ui/FormInput';
  import Form from '@/components/common/Form';
  import { validationMixin } from 'vuelidate';
  import { minLength, required } from 'vuelidate/lib/validators';
  import sameAs from 'vuelidate/lib/validators/sameAs';
  import Vector from '@/assets/icons/vector.svg';
  import passwordValidation from '@/utils/validation';
  import Button from '@/components/ui/Button';
  import { mapActions, mapMutations } from 'vuex';
  import request from '@/utils/api/request';
  import { changeLocale } from '@/i18n';

  export default {
    name: 'InfoRegister',
    components: {
      FormInput,
      Form,
      Vector,
      Button,
    },
    mixins: [validationMixin],
    data() {
      return {
        team: '',
        name: '',
        email: '',
        password: '',
        password2: '',
        phone: '',
        position: '',
        isLoading: false,
        isDone: false,
        serverErrors: {
          email: null,
          phone_number: null,
        },
      };
    },
    async created() {
      try {
        let { data } = await request.get(`/register/invitation/${this.$route.params.hash}/`);

        changeLocale(data.language);
        this.name = data.inviter_user_name;
        this.team = data.inviter_team_name;
        this.email = data.email;
      } catch {
        await this.$router.push({ name: 'login' });
      }
    },
    validations: {
      name: { required, minLength: minLength(2) },
      email: { required },
      phone: { required },
      position: { required },
      password: {
        required,
        minLength: minLength(6),
        passwordValidation,
      },
      password2: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
    computed: {
      samePasswords() {
        return this.$v.password.required && this.$v.password2.sameAsPassword;
      },
    },
    methods: {
      ...mapMutations('auth', ['setRegistrationInfo', 'setPassword']),
      ...mapActions('auth', ['setToken']),
      async submit() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.isLoading = true;
        this.serverErrors = {
          email: null,
          phone_number: null,
        };

        try {
          let { data } = await request.post('/confirm_invitation/', {
            name: this.name,
            password: this.password,
            phone_number: this.phone,
            position: this.position,
            hash_string: this.$route.params.hash,
          });

          this.setToken(data.register_finish_token);

          this.isDone = true;
          this.setRegistrationInfo({
            email: this.email,
            company: this.team,
          });
          this.setPassword(this.password);
          this.$emit('change-step', 2);
        } catch (e) {
          this.serverErrors = e.response.data;
        }

        this.isLoading = false;
      },
    },
  };
</script>
